import client from "./utils/client/client";

class Error {

	constructor(dataJson) {
		this.status = null;
		this.descriptor = null;
		this.title = "Error inesperado";
		this.message = "Ocurrio un error inesperado";
		this.developerMessage = null;

		if (dataJson !== undefined) {
			this.status = dataJson.status;
			this.descriptor = dataJson.descriptor;
			this.title = dataJson.title;
			this.message = dataJson.message;
			this.developerMessage = dataJson.developerMessage;
		}
	}

}

class Api {

	constructor(baseUrl) {
		this.baseUrl = baseUrl;
		this.client = client;
	}

	extractError(error) {
		if (error.response !== undefined && error.response.data.descriptor != null) {
			return new Error(error.response.data);
		} else {
			return new Error();
		}
	}

	loadBinary(url,  callbacks) {
		if (callbacks === undefined)
    		callbacks = {}
  
	  	let anchor = document.createElement("a");
	  	document.body.appendChild(anchor);

	  	this.client.get(url, {responseType: 'blob', onDownloadProgress: progressEvent => { 
	      	if (callbacks.onDownloadProgress !== undefined) {
		        const total = progressEvent.total
		        const current = progressEvent.loaded
		        let percentCompleted = Math.floor(current / total * 100)
		        callbacks.onDownloadProgress(percentCompleted); 
	      	}
		}}).then((response) => {
		    let fileName = response.headers["content-disposition"].split("filename=")[1];
		    if (fileName.charAt(0) === "\"" && fileName.charAt(fileName.length-1) === "\"")
		      fileName = fileName.substring(1,fileName.length-1);

		    var file = new Blob([response.data], { type: response.headers["content-type"] });
		    let objectUrl = window.URL.createObjectURL(file);
		    anchor.download = fileName
		    anchor.href = objectUrl;

		    anchor.click();
		    if (callbacks.success !== undefined)
		      	callbacks.success(file, objectUrl);
		}).catch((error) => {
    		if (callbacks.error !== undefined)
      			callbacks.error(this.extractError(error));
  		});
	}

	uploadBinary(url, binary, callbacks) {
		if (callbacks === undefined)
			callbacks = {}

		this.client.post(url,binary, {
			onUploadProgress: data => {
				if (callbacks.onUpdateProgress !== undefined) {
					callbacks.onUpdateProgress(Math.round((100 * data.loaded) / data.total));
				}
			}
		}).then((response) => {
			if (callbacks.success !== undefined)
				callbacks.success(response.data);
		}).catch((error) => {
			if (callbacks.error !== undefined)
				callbacks.error(this.extractError(error));
		});
	}

}

export default Api;